export const CURRENCIES = {
  eur: { symbol: "€", code: "EUR", symbolBefore: true },
  czk: { symbol: "Kč", code: "CZK", symbolBefore: false },
};

export function curInfo(cur) {
  return CURRENCIES[(cur || "eur").toLowerCase()] || CURRENCIES.eur;
}

export function money(amount, cur = "eur") {
  const c = curInfo(cur);
  const n = amount ?? 0;
  return c.symbolBefore ? `${c.symbol}${n}` : `${n} ${c.symbol}`;
}
